import { render, staticRenderFns } from "./ModalShowNullifiedService.vue?vue&type=template&id=0bc1bdb4"
import script from "./ModalShowNullifiedService.vue?vue&type=script&lang=js"
export * from "./ModalShowNullifiedService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports